import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../../../infra/dls/components/button/button';
import { TextM } from '../../../infra/dls/components/typography';
import { t } from '../../../infra/i18n';
import AiIcon from './icons/ai.svg';
import styles from './styles.module.scss';
export var BotToggleButton = function (_a) {
    var onClick = _a.onClick;
    return (_jsx(Button.Secondary, { type: "button", onClick: onClick, className: styles.toggleButton, children: _jsx("div", { className: styles.glowingBorder, children: _jsxs("div", { className: styles.contentContainer, children: [_jsx(AiIcon, {}), _jsx(TextM, { color: "secondary", children: t('reports:ai_bot.search_button') })] }) }) }));
};
